import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import {DEFER_INIT_EVENTS} from "../constants/global";
import MultCoachesBar from "./mult-coaches-bar";
import SimpleVideo from "./simple-video";
import ServiceLocator from "../services/service-locator";

export default class ReviewsSlider {
    constructor(props = {}) {
        this.$root = document.getElementById('reviewsSlider');

        if (this.$root) {
            this.$slides = this.$root.querySelectorAll('.swiper-slide');
            this.$coaches = this.$root.querySelectorAll('[data-coach-id]');

            this.sl = ServiceLocator.instance;
            this.shouldDeferInit = props.shouldDeferInit == null ? true : props.shouldDeferInit;
            this.videoList = [];
            this.swiper = null;

            this.config = {
                modules: [Navigation],
                navigation: {
                    prevEl: '#reviewsSlider .swiper-button-prev',
                    nextEl: '#reviewsSlider .swiper-button-next'
                },
                spaceBetween: 30,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: this.$slides.length > 1,
                autoHeight: true,
                watchSlidesProgress: true,
                on: {
                    init: function () {
                        setTimeout(() => {
                            this.updateAutoHeight(250);
                        }, 250);
                    },
                    slideChange: () => {
                        if (this.videoList.length) {
                            this.videoList.forEach((video) => {
                                video.pause();
                            });
                        }
                    }
                }
            };

            if (this.shouldDeferInit) {
                this.deferInit();
            } else {
                this.init();
            }
        }
    }

    init() {
        this.initVideo();
        this.bootstrap();
        this.initMultCoachesBars();
        new ReviewsCoachesModal(this.$coaches);
    }

    deferInit() {
        const events = DEFER_INIT_EVENTS;
        const handler = e => {
            e.stopPropagation();

            this.initVideo();
            this.bootstrap();
            this.initMultCoachesBars();
            new ReviewsCoachesModal(this.$coaches);
            this.sl.lazyLoadInstance.update();

            events.forEach(event => {
                window.removeEventListener(event, handler);
            });
        };


        events.forEach(event => {
            window.addEventListener(event, handler);
        });
    }

    initMultCoachesBars() {
        const $bars = this.$root.querySelectorAll('.mult-coaches-bar');
        if ($bars.length) {
            $bars.forEach(($bar) => {
                const multCoachesBar = new MultCoachesBar({ $root: $bar });

                multCoachesBar.collapsible.subscribe('toggleCollapsible', () => {
                    this.swiper.updateAutoHeight(360);
                });
            });
        }
    }

    bootstrap() {
        this.swiper = new Swiper(this.$root, this.config);
    }

    initVideo() {
        const $videos = this.$root.querySelectorAll('.review-video');

        if (!$videos.length) return;

        this.videoList = Array.from($videos).map(($video) => new SimpleVideo($video));
    }
}

class ReviewsCoachesModal {
    constructor($triggers) {
        this.$triggers = $triggers;
        this.$modal = document.getElementById('modal-reviews-coaches');
        this.$modalContentItems = this.$modal.querySelectorAll('.coaches-modal-content');

        this.sl = ServiceLocator.instance;

        if ($triggers && $triggers.length) {
            this.init();
        }
    }

    init() {
        this.sl.modalService.register('reviews-coaches', Array.from(this.$triggers), {
            beforeOpen: ($trigger) => {
                this.setActive($trigger.dataset.coachId);
            }
        });
    }

    getItemIndexById(id) {
        return Array.from(this.$modalContentItems).findIndex($item => $item.dataset.id === id);
    }

    setActive(id) {
        const index = this.getItemIndexById(id);
        this.$modalContentItems.forEach($item => $item.classList.remove('-show'));
        this.$modalContentItems[index].classList.add('-show');
    }
}